import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "../../common/index.scss";
import Slider from "react-slick";

// Import custom components
import Header from "../header/header";
import SpecialProducts from "./special-products";
import Products from "../products/products"; // <-- Import at the top
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getCurrencySymbol,
  getOpenStoreIdApp,
  formatPrice,
} from "../../../store/index";
import { getCall, postCall } from "../../../api/post";
import MainFooter from "../../layouts/footer/main_footer";
import {
  getImageUrl,
  getPlaceHolderImage,
  getSettingUrl,
  getOfferBannerUrl,
  getMerchantInformationUrl,
  getCatalogueJewellaryUrl,
  getPlaceHolderBanner,
  getAddToWishlistUrl,
} from "../../../services";
import NotificationList from "../notifications/notification-list";
import Drawer from "@material-ui/core/Drawer";
import { connect } from "react-redux";
import {
  getCommonCounter,
  getNotificationCounter,
  getUpdateQuantity,
  getWishlist,
  isInquiryOrCart,
  setHeaderCounters,
} from "../../../actions";
import { NotificationContainer } from "react-notifications";

// import ThemeSettings from "../../common/theme-settings";
import { isMobile } from "react-device-detect";
import MainLoader from "../../../animation/MainLoader";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../utils/utils";
import { withRouter } from "react-router-dom";
import AddToCartAnim from "../../../animation/AddToCartAnim";
import QuickViewProductDetailsModal from "./quick-view-product-details-modal";
import AddToWishListAnim from "../../../animation/AddToWishListAnim";
import {
  checkAuthAndRedirect,
  getCurrentPath,
} from "../../../utils/cartRedirect";

const notificationHeaderStyle = {
  textTransform: "uppercase",
  fontSize: "18px",
  padding: "15px",
  fontWeight: "400",
  color: "#222222",
  backgroundColor: "#F0F0F0",
};

class Dashboard extends Component {
  state = {
    productsNewArrival: [],
    productsBestSelling: [],
    isDrawerVisible: false,
    isLoading: false,
    offerBanners: [],
    AppTitle: "",
    currentCatelogueType: {},
    showErrorMessageModal: false,
    errorMessage: "",
    isContentLoaderVisible: false,
    showAddToCartMessageModal: false,
    addToCartMessage: "",
    isQuickViewProductDetailsModalShow: false,
  };

  componentDidMount() {
    // document
    //   .getElementById("color")
    //   .setAttribute("href", `${process.env.PUBLIC_URL}/assets/css/color7.css`);

    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      this.props.history.push(`/login`);
      return;
    }
    this.initMerchantInfo();
    this.initNewAndBestSellingProducts();
    this.initOfferBanner();
    this.initCatelogueSettings();
    const { masterDetailsObj } = this.props;
    this.props.isInquiryOrCart(masterDetailsObj);
    const { id } = userDetails || {};
    if (id) {
      this.props.getWishlist(id);
    }
    this.props.notificationCounter();
  }

  initNewAndBestSellingProducts = () => {
    this.setState({ isLoading: true }, () => {
      this.initProductListNewArrival();
      this.initProductListBestSelling().then(() => {
        this.setState({ isLoading: false });
      });
    });
  };

  initProductListNewArrival = async () => {
    const productListUrl =
      "products?filter[include]=productbrand&filter[include]=productmedia&filter[order][0]=created DESC&filter[include]=category&filter[where][productstatus]=1&filter[where][availablequantity][gt]=0&filter[skip]=0&filter[limit]=20";
    const products = await getCall(productListUrl, []);
    if (products.error) {
      clearLocalStorageReload({ response: products });
      this.loadErrorMessageAnimation(products.error.message);
      if (products.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      // Ensure productsNewArrival is always an array
      const productsArray = Array.isArray(products) ? products : [];
      this.setState({ productsNewArrival: productsArray });
    }
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.props;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.loadErrorMessageAnimation(merchantInfo.error.message);
      this.setState({
        isMerchantGSTEnable: false,
        merchantInfo: {},
        AppTitle: "",
      });
    } else {
      this.setState({
        merchantInfo,
        AppTitle: merchantInfo.companyname,
        isMerchantGSTEnable: merchantInfo.enablegst === 0 ? false : true,
      });
    }
  };

  initCatelogueSettings = async () => {
    const { masterDetailsObj } = this.props;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const settingInfo = await getCall(settingUrl, []);
    if (settingInfo.error) {
      clearLocalStorageReload({ response: settingInfo });
      this.loadErrorMessageAnimation(settingInfo.error.message);
    } else {
      let settings = {};
      settingInfo.forEach((setting) => {
        if (
          (setting.registerallow === "Catalogue_FMCG" ||
            setting.registerallow === "Catalogue_Jewellary" ||
            setting.registerallow === "Catalogue_Electronics" ||
            setting.registerallow === "Catalogue_FABRIC") &&
          setting.status === 1
        ) {
          settings = setting;
        }
      });
      if (settings && settings.registerallow === "Catalogue_Jewellary") {
        this.initGoldPriceJwelleryCatelogue();
      }
    }
  };

  initSingleCategry = async (product) => {
    const { category } = product || {};
    const [firstCategory] = Array.isArray(category) ? category : [];
    const { category: ctr } = firstCategory || {};
    const { parentId } = ctr || {};
    if (parentId) {
      const singleCategoryUrl = "categories/" + parentId;
      const singleCategory = await getCall(singleCategoryUrl, []);
      if (singleCategory.error) {
        clearLocalStorageReload({ response: singleCategory });
        this.loadErrorMessageAnimation(singleCategory.error.message);
        if (singleCategory.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else {
        this.setState({ category: singleCategory });
      }
    }
  };

  fetchHeaderCounters = async () => {
    try {
      const response = await getCall("v2/dashboard/header-counters", []);
      if (response.error) {
        return;
      }
      this.props.setHeaderCounters(response); // <-- dispatch to Redux
    } catch (e) {}
  };

  // Best Selling
  initProductListBestSelling = async () => {
    const productListUrl =
      "products?filter[include]=productbrand&filter[include]=productmedia&filter[include]=category&filter[where][productstatus]=1&filter[where][availablequantity][gt]=0&filter[order][0]=sellcounter DESC&filter[skip]=0&filter[limit]=20";
    const products = await getCall(productListUrl, []);
    if (products.error) {
      clearLocalStorageReload({ response: products });
      this.loadErrorMessageAnimation(products.error.message);
      if (products.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      // Ensure productsBestSelling is always an array
      const productsArray = Array.isArray(products) ? products : [];
      this.setState({ productsBestSelling: productsArray });
    }
  };

  initOfferBanner = async () => {
    try {
      const { masterDetailsObj } = this.props;
      const offerBannerUrl = getOfferBannerUrl(masterDetailsObj);
      const offerBanners = await getCall(offerBannerUrl, []);
      if (offerBanners.error) {
        clearLocalStorageReload({ response: offerBanners });
        this.loadErrorMessageAnimation(offerBanners.error.message);
        if (offerBanners.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else {
        // const banner = offerBanners.map((banner) => {
        //   return banner.media.length > 0 ? banner.media[0].image : "";
        // });
        this.setState({ offerBanners });
      }
    } catch (error) {
      this.setState({ offerBanners: [] });
    }
  };

  initGoldPriceJwelleryCatelogue = async () => {
    const { masterDetailsObj } = this.props;
    const goldPriceUrl = getCatalogueJewellaryUrl(masterDetailsObj);
    const goldPrice = await getCall(goldPriceUrl, []);
    if (goldPrice.error) {
      clearLocalStorageReload({ response: goldPrice });
      this.loadErrorMessageAnimation(goldPrice.error.message);
    } else {
      if (goldPrice.length > 0 && goldPrice[0].status === 1) {
        this.setState({ goldPrice: goldPrice[0].text });
      }
    }
  };

  handleNotificicationDrawer = () => {
    const { isDrawerVisible } = this.state;
    this.setState({ isDrawerVisible: !isDrawerVisible });
  };

  onClickOnSettingsIcon = () => {
    this.props.history.push(`/settings`);
  };

  onCloseofNotificationDrawer = () => {
    this.setState({ isDrawerVisible: false });
    this.props.notificationCounter();
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadAddToCartMessageAnimation = (message) => {
    this.setState({
      addToCartMessage: message,
      showAddToCartMessageModal: true,
    });
  };

  loadAddToWishListMessageAnimation = (message) => {
    this.setState({
      addToWishListMessage: message,
      showAddToWishListMessageModal: true,
    });
  };

  showQuickViewProductDetailsModal = () => {
    this.setState({ isQuickViewProductDetailsModalShow: true });
  };

  hideQuickViewProductDetailsModal = () => {
    this.setState({ isQuickViewProductDetailsModalShow: false });
  };

  onClickOfOfferBanner = (banner) => {
    const { link: links } = banner;

    links.map((linkItem, index) => {
      const { productId, categoryId, link } = linkItem;
      if (productId) {
        this.props.history.push(`/singleproduct/${productId}`);
      }
      if (categoryId) {
        this.props.history.push(`/c/${categoryId}`);
      }
      if (link) {
        window.open(link, "_blank");
      }
      return null;
    });
  };

  renderOfferBanners = () => {
    const { offerBanners } = this.state;
    // API response shape: { banners: [ ... ] }
    const bannersArr =
      offerBanners && offerBanners.banners ? offerBanners.banners : [];
    // Banner width matches product card row, with same left/right space, increased height, more space above, and improved style
    const bannerContainerStyle = {
      width: "100%",
      maxWidth: "1300px",
      aspectRatio: "649 / 150", // <-- Force aspect ratio to 649:150
      margin: "40px auto 8px auto",
      background: "linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%)",
      borderRadius: "20px",
      boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid #e2e8f0",
    };

    const bannerImageStyle = {
      width: "100%",
      height: "100%",
      objectFit: "contain", // Fill container, keep aspect ratio
      display: "block",
      cursor: "pointer",
      borderRadius: "20px",
      background: "transparent",
      boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
    };

    if (!bannersArr.length) {
      // fallback to static banner if no banners
      return (
        <div style={bannerContainerStyle}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/razrewardbanner.jpg`}
            alt="RazReward Banner"
            style={bannerImageStyle}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = getPlaceHolderBanner();
            }}
          />
        </div>
      );
    }

    // If only one banner, show as static image. If multiple, use slider.
    if (bannersArr.length === 1) {
      const banner = bannersArr[0];
      const imageObj =
        banner.media && banner.media.length > 0 ? banner.media[0] : null;
      const imageName = imageObj && imageObj.image ? imageObj.image : null;
      const imageUrl = imageName
        ? getImageUrl(imageName, this.props.masterDetailsObj)
        : getPlaceHolderBanner();
      return (
        <div style={bannerContainerStyle}>
          <img
            key={banner.id}
            src={imageUrl}
            alt={imageName || "Offer Banner"}
            style={bannerImageStyle}
            onClick={() => this.onClickOfOfferBanner(banner)}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = getPlaceHolderBanner();
            }}
          />
        </div>
      );
    }
    // Multiple banners: use react-slick slider, full size, with navigation
    const sliderContainerStyle = {
      borderRadius: "20px",
      boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
      overflow: "hidden",
      border: "1px solid #e2e8f0",
      position: "relative",
      height: "300px",
    };

    const bannerStyle = {
      width: "100%",
      height: isMobile ? "200px" : "300px",
      objectFit: "contain",
      display: "block",
      cursor: "pointer",
      // backgroundColor: "#000", // optional fill for empty space
    };

    // Custom arrow components for react-slick
    const ArrowStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(255,255,255,0.95)",
      border: "1px solid #222",
      borderRadius: "50%",
      width: 30,
      height: 30,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      zIndex: 10,
      top: "50%",
      transform: "translateY(-50%)",
      position: "absolute",
      cursor: "pointer",
      color: "#222",
      fontSize: 18,
      fontWeight: 700,
      transition: "box-shadow 0.2s",
    };
    const NextArrow = (props) => {
      const { className, style, onClick } = props;
      return (
        <div
          className={className}
          style={{ ...ArrowStyle, right: 17, ...style }}
          onClick={onClick}
        >
          <span
            style={{
              fontSize: 24,
              lineHeight: 1,
              fontWeight: 700,
              color: "#222",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transform: "translateY(-20px)",
            }}
          >
            &#8250;
          </span>
        </div>
      );
    };
    const PrevArrow = (props) => {
      const { className, style, onClick } = props;
      return (
        <div
          className={className}
          style={{ ...ArrowStyle, left: 17, ...style }}
          onClick={onClick}
        >
          <span
            style={{
              fontSize: 24,
              lineHeight: 1,
              fontWeight: 700,
              color: "#222",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transform: "translateY(-20px)",
            }}
          >
            &#8249;
          </span>
        </div>
      );
    };
    const sliderSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 4000,
      adaptiveHeight: false,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    };
    return (
      <div className="container">
        <div style={sliderContainerStyle}>
          <Slider {...sliderSettings}>
            {bannersArr.map((banner, idx) => {
              const imageObj =
                banner.media && banner.media.length > 0
                  ? banner.media[0]
                  : null;
              const imageName =
                imageObj && imageObj.image ? imageObj.image : null;
              const imageUrl = imageName
                ? getImageUrl(imageName, this.props.masterDetailsObj)
                : getPlaceHolderBanner();
              return (
                <div key={banner.id || idx} style={{ position: "relative" }}>
                  <img
                    src={imageUrl}
                    alt={imageName || "Offer Banner"}
                    style={bannerStyle}
                    onClick={() => this.onClickOfOfferBanner(banner)}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = getPlaceHolderBanner();
                    }}
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    );
  };

  addToCart = async (product, qty, isInquiry) => {
    if (qty === "") {
      return;
    }
    const { counter, updateQuantity } = this.props;
    try {
      // Check authentication first
      const currentPath = getCurrentPath(this.props);
      if (!checkAuthAndRedirect(this.props, currentPath)) {
        return; // User was redirected to login
      }

      let userDetails = loadUserDetailsFromLocalStorage();
      if (!isOpenStoreIdExist() && userDetails === undefined) {
        return;
      } else {
        userDetails = userDetails === undefined ? {} : userDetails;
      }
      const { id, cityId } = userDetails;
      const openStoreId = getOpenStoreIdApp();
      let userId = openStoreId ? openStoreId : id;

      const addtocartUrl = isInquiry
        ? "orders/productInquiry"
        : "orders/addtocart";

      let addtocartObj = {
        orderstatus: 1,
        inshoppingcart: 1,
        userId,
        totalamount: isInquiry ? 0 : product.price * qty,
        orderdetails: [
          {
            quantity: qty,
            productId: product.id,
          },
        ],
        cityId: cityId,
        date: new Date(),
      };

      const addToCartResponse = await postCall(addtocartUrl, addtocartObj);

      if (addToCartResponse.error) {
        clearLocalStorageReload({ response: addToCartResponse });
        this.loadErrorMessageAnimation(addToCartResponse.error.message);
        if (addToCartResponse.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else if (
        addToCartResponse.message &&
        (addToCartResponse.message === "Sorry! Product is out of stock" ||
          addToCartResponse.message ===
            "Sorry! Product is not availble as per given quantity")
      ) {
        // Handle out of stock or insufficient quantity message
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_product_out_of_stock") ||
            addToCartResponse.message ||
            "Sorry! Product is out of stock"
        );
        return;
      } else {
        if (isInquiry) {
          this.loadAddToCartMessageAnimation(
            getValueFromLanguageObject("str_add_to_inquiry_successfully")
              ? getValueFromLanguageObject("str_add_to_inquiry_successfully")
              : "Product inquiry added successfully"
          );
        } else {
          this.loadAddToCartMessageAnimation(
            getValueFromLanguageObject("str_add_to_cart_successfully")
              ? getValueFromLanguageObject("str_add_to_cart_successfully")
              : "Product added to cart successfully"
          );
        }
        this.hideQuickViewProductDetailsModal();

        // Add a small delay to ensure backend has finished updating the counter
        setTimeout(async () => {
          await counter();
          await this.fetchHeaderCounters();
          updateQuantity();
        }, 500);
      }
    } catch (error) {
      // Handle error silently to avoid UI flicker
    }
  };

  onAddToWishlistClicked = async (product) => {
    try {
      this.setState({ isLoading: true });
      const { wishlist } = this.props || {};
      const [wishlistDefault] = Array.isArray(wishlist) ? wishlist : [];
      let userDetails = loadUserDetailsFromLocalStorage();
      const { id: userId } = userDetails || {};
      const { id: productId } = product || {};
      const addtowishlistObj = {
        wishlistId: wishlistDefault.id,
        userId,
        productId,
      };
      const addToWishlistUrl = getAddToWishlistUrl();
      const addToCartResponse = await postCall(
        addToWishlistUrl,
        addtowishlistObj
      );
      const { error } = addToCartResponse || {};
      this.setState({ isLoading: false });
      if (error) {
        clearLocalStorageReload({ response: addToCartResponse });
        this.loadErrorMessageAnimation(error.message);
        if (error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
        return;
      } else {
        const successMessage =
          getValueFromLanguageObject("str_add_to_wishlist_successfully") ||
          "Product added to wishlist successfully";
        this.loadAddToWishListMessageAnimation(successMessage);
      }
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handleClickOfQuickView = (product) => {
    this.setState({ product }, () => {
      this.initSingleCategry(product);
      this.showQuickViewProductDetailsModal();
    });
  };

  render() {
    const {
      isDrawerVisible,
      isLoading,
      goldPrice,
      AppTitle,
      currentCatelogueType,
      showErrorMessageModal,
      errorMessage,
      productsNewArrival,
      productsBestSelling,
      showAddToCartMessageModal,
      showAddToWishListMessageModal,
      addToCartMessage,
      addToWishListMessage,
      isQuickViewProductDetailsModalShow,
      category,
      product,
    } = this.state;
    const { symbol, isInquiry, masterDetailsObj } = this.props;
    return (
      <>
        <div className="">
          <NotificationContainer />
          <Helmet>
            <title>
              {getValueFromLanguageObject("str_welcome_to") || "Welcome To"}{" "}
              {AppTitle}
            </title>
          </Helmet>
          <Header
            handleNotificicationDrawer={this.handleNotificicationDrawer}
            onClickOnSettingsIcon={this.onClickOnSettingsIcon}
          />
          <section className="p-0" style={{ marginTop: "95px" }}>
            {this.renderOfferBanners()}
          </section>

          {/* --- THIS IS THE ONLY CHANGE YOU NEED --- */}
          <Products showBreadcrumb={false} />

          <MainFooter />
          {/* <ThemeSettings /> */}
        </div>
        {isLoading && <MainLoader />}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {showAddToCartMessageModal && (
          <AddToCartAnim
            show={showAddToCartMessageModal}
            message={addToCartMessage}
            onClose={() => {
              this.setState({ showAddToCartMessageModal: false });
            }}
          />
        )}

        {showAddToWishListMessageModal && (
          <AddToWishListAnim
            show={showAddToWishListMessageModal}
            message={addToWishListMessage}
            onClose={() => {
              this.setState({ showAddToWishListMessageModal: false });
            }}
          />
        )}

        {isQuickViewProductDetailsModalShow && (
          <QuickViewProductDetailsModal
            product={product}
            category={category}
            masterDetailsObj={masterDetailsObj}
            symbol={symbol}
            isInquiry={isInquiry}
            onAddToCartClicked={this.addToCart}
            isQuickViewProductDetailsModalShow={
              isQuickViewProductDetailsModalShow
            }
            handleCloseQuickViewProductDetailsModal={
              this.hideQuickViewProductDetailsModal
            }
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  symbol: getCurrencySymbol(),
  isInquiry: state.settings.isInquiry,
  wishlist: state.settings.wishlist,
});

export default connect(mapStateToProps, {
  counter: getCommonCounter,
  notificationCounter: getNotificationCounter,
  isInquiryOrCart: isInquiryOrCart,
  updateQuantity: getUpdateQuantity,
  getWishlist: getWishlist,
  setHeaderCounters,
})(withRouter(Dashboard));
